import { styled } from '@mui/material/styles';
import { default as BaseItem } from './Item';
import { default as BaseItemDesktop } from './DesktopItem';
import { default as BaseItemMobile } from './MobileItem';

export const Item = styled(BaseItem)(({ theme, grow }) => ({
  boxSizing: 'border-box',
  flexGrow: grow || 0,
  flexShrink: 0,
  minWidth: '200px',
  padding: theme.spacing(2),
  whiteSpace: 'normal',
  '@media (min-width: 1101px)': {
    flexBasis: '33%'
  },
  '@media (max-width: 1100px) and (min-width: 501px)': {
    flexBasis: '50%'
  },
  '@media (max-width: 500px)': {
    flexBasis: '100%'
  }
}));

export const DesktopItem = styled(BaseItemDesktop)(({ theme, grow }) => ({
  boxSizing: 'border-box',
  flexGrow: grow || 0,
  flexShrink: 0,
  minWidth: '200px',
  padding: theme.spacing(2),
  whiteSpace: 'normal',
  paddingBottom: '8px',
  paddingTop: '8px',
  '@media (min-width: 1101px)': {
    flexBasis: '33%'
  },
  '@media (max-width: 1100px) and (min-width: 501px)': {
    flexBasis: '50%'
  },
  '@media (max-width: 500px)': {
    flexBasis: '100%'
  }
}));

export const MobileItem = styled(BaseItemMobile)(({ theme, grow }) => ({
  boxSizing: 'border-box',
  flexGrow: grow || 0,
  flexShrink: 0,
  minWidth: '200px',
  padding: theme.spacing(2),
  whiteSpace: 'normal',
  paddingBottom: '4px',
  '@media (max-width: 500px)': {
    flexBasis: '100%'
  }
}));

export const ExperienceAbroadHeader = styled(BaseItemDesktop)(({ theme, grow }) => ({
  boxSizing: 'border-box',
  flexGrow: grow || 0,
  flexShrink: 0,
  minWidth: '200px',
  padding: theme.spacing(2),
  whiteSpace: 'normal',
  paddingBottom: '0px',
  paddingTop: '8px',
  '@media (min-width: 1101px)': {
    flexBasis: '33%'
  },
  '@media (max-width: 1100px) and (min-width: 501px)': {
    flexBasis: '50%'
  },
  '@media (max-width: 500px)': {
    flexBasis: '100%'
  }
}));

export const DescriptionItem = styled(BaseItem)(({ theme, grow }) => ({
  boxSizing: 'border-box',
  flexGrow: grow || 0,
  flexShrink: 0,
  padding: theme.spacing(2),
  '@media (min-width: 1101px)': {
    flexBasis: '100%'
  },
  '@media (max-width: 1100px) and (min-width: 501px)': {
    flexBasis: '100%'
  },
  '@media (max-width: 500px)': {
    flexBasis: '100%'
  }
}));

export const DetailsRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap'
}));

export const DetailedView = styled('div')(() => ({
  width: '100%'
}));

export const DetailsWrapper = styled('div')(() => ({}));

// @TODO clean this file
export const Title = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.large,
  fontWeight: theme.fontWeight.normal,
  lineHeight: theme.spacing(3),
  margin: theme.spacing(2),
  textAlign: 'left',
  textTransform: 'uppercase',
  width: '100%'
}));

export const TitleDescription = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.base,
  fontWeight: theme.fontWeight.bold,
  lineHeight: theme.spacing(2),
  margin: '16px 16px 0px 16px',
  textAlign: 'left',
  width: '100%'
}));

export const Container = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  '& hr': {
    borderTop: `1px solid ${theme.color.grey[500]}`,
    borderBottom: 'none',
    margin: 0
  },
  '& .compParent': {
    wordBreak: 'break-all',
    padding: '15px 0',
    '& h2': {
      wordBreak: 'break-all',
      fontSize: theme.fontSize.large
    }
  },
  '& .clt, & .clt .list, & .clt .listItem': {
    position: 'relative',
    width: '100%'
  },
  '& .clt .list': {
    listStyle: 'none',
    paddingLeft: '15px',
    marginTop: '10px',
    boxSizing: 'border-box',
    marginBottom: '16px',
    marginTop: '15px'
  },
  '& .clt .list .listItem': {
    marginTop: '10px',
    width: '100%'
  },
  '& .clt .listItem::before, & .clt .listItem::after': {
    content: '""',
    position: 'absolute',
    left: '-12px'
  },
  '& .clt .listItem::before': {
    borderTop: '1px solid #444444',
    top: '12px',
    width: '8px',
    height: '1px'
  },
  '& .clt .listItem::after': {
    borderLeft: '1px solid #444444',
    height: 'calc(100% + 10px)',
    width: '1px',
    top: '-5px'
  },
  '& .clt .list > .listItem:last-child::after': {
    height: '34px'
  },
  '& .clt p': {
    lineHeight: '1.4'
  },
  '& .compParent h2.WexpGroupName': {
    fontWeight: 400,
    color: '#444',
    fontSize: '24px',
    marginTop: '10px',
    lineHeight: '1.083',
    marginBottom: '5px'
  },
  '& .compParent': {
    marginLeft: '-7px',
    padding: 0,
    '& > div': {
      display: 'inline-flex'
    },
    '& .CompanyGroup-btn': {
      marginTop: '5px',
      marginLeft: '5px',
      padding: 0
    },
    '& .comp_edit_btn': {
      position: 'relative',
      padding: '10px 17px',
      '& > svg': {
        position: 'absolute',
        top: '2px'
      }
    },
    '& .comp_name': {
      marginTop: '-8px'
    },
    '& .list li.listItem': {
      paddingLeft: '20px',
      // width: 'calc(100% - 20px)',
      paddingTop: '10px',
      marginTop: '0px'
    },
    '& li.listItem::before': {
      top: '18px'
    },
    '& div.listItem::before': {
      top: '18px'
    },
    '& .list div.listItem': {
      marginTop: 0,
      alignItems: 'flex-start'
    },
    '& div.listItem': {
      paddingTop: '10px',
      '& > a': {
        paddingTop: 0,
        paddingBottom: 0,
        border: 'none',
        color: theme.color.primary.main,
        marginLeft: '10px',
        fontSize: '12px'
      }
    },
    '& .listItem::before': {
      width: '25px !important'
    },
    '& .compPost-btn': {
      position: 'relative',
      marginLeft: '5px',
      paddingTop: '3px',
      '& > svg': {
        position: 'absolute',
        top: 0,
        height: '14px',
        color: theme.color.primary.main
      }
    },
    '& .compPost-title': {
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '1.25',
      color: theme.color.primary.main
    },
    '& > div': {
      paddingBottom: '5px'
    },
    '& > .list > .listItem::after': {
      top: '-15px',
      height: 'calc(100% + 33px)'
    },
    '& .CompanyGroup-btn > svg': {
      height: '22px'
    },
    '& .compAddPosition': {
      marginTop: '0px'
    },
    '& .compDivider': {
      margin: '7px auto 13px'
    },
    '& .textClass + div': {
      backgroundColor: '#fff',
      '& button': {
        fontSize: '13px'
      }
    },
    '& .textClass': {
      paddingRight: '110px'
    },
    '& .textClass + div button': {
      marginTop: '-25px'
    },
    '& .compGroup-btn > svg, & .textClass + div button > span': {
      color: theme.color.primary.main
    },
    '& .compExp-divider': {
      marginTop: '-10px',
      marginBottom: '20px'
    },
    '& .add-comp-grp': {
      display: 'flex !important',
      marginBottom: '10px'
    },
    '& .position-Tag': {
      clear: 'both',
      marginBottom: '5px'
    },
    '& > div': {
      width: '100%'
    },
    '& .textClass + div .MuiCollapse-wrapperInner': {
      paddingBottom: '15px'
    },
    '& > .list > .listItem:only-child::after, & > .list > .listItem:last-child::after': {
      height: '34px'
    },
    '& .des-content': {
      padding: '8px 16px 0px 16px'
    }
  }
}));

export const DottedHR = styled('div')(() => ({
  borderTop: '2px dotted #CCCCCC'
}));
